import { CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { SWRConfig } from 'swr';
import { AuthProvider } from '@/auth/AuthContext';
import { theme } from '@/theme/theme';
import { swrFetcher } from '@/api/client';
import { AppRoutes } from '@/routes/AppRoutes';
import { ToasterProvider } from '@/components/Toaster';

/**
 * Composition root. Order matters:
 *   ThemeProvider     → MUI components and our theme tokens
 *   SWRConfig         → default fetcher + cache mode for every useSWR
 *   BrowserRouter     → routing
 *   AuthProvider      → auth state (consumes routing for redirects)
 *   ToasterProvider   → transient feedback overlay (PR-D)
 *   AppRoutes         → the route tree
 */
export function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SWRConfig
        value={{
          fetcher: swrFetcher,
          revalidateOnFocus: false,
          shouldRetryOnError: false,
          dedupingInterval: 4_000,
        }}
      >
        <BrowserRouter>
          <AuthProvider>
            <ToasterProvider>
              <AppRoutes />
            </ToasterProvider>
          </AuthProvider>
        </BrowserRouter>
      </SWRConfig>
    </ThemeProvider>
  );
}
